module.exports = __webpack_public_path__ + "img/banner.d5ac8da0.png";